import { orderFilterOptions } from './filter-options/options';
import { id as billToPartyFilterId } from '../../filters/options/shippingBillToParty';
import { id as shippingAccountFilterId } from '../../filters/options/shippingAccount';
import { BillToParty, ACCOUNT } from '../../enums/bill-to-party';
import { OptionFormTypes } from '../../services/filtering/filter-form-render-service/option-form-types';

export const mapCollectionFilters = (filter) => {
  const { filterById, criterionArgumentValue, criterionOperatorValue, criterionMeta, type } = filter;
  const matchedFilter = orderFilterOptions.find((f) => f.id === filterById);
  // orders grid shippingAccountFilterId uses criterionMeta, shipping grid version does not
  const adjustedFilterById =
    filterById === shippingAccountFilterId && criterionMeta && criterionMeta.value !== ACCOUNT ? billToPartyFilterId : filterById;
  const adjustedCriterionArgumentValue =
    adjustedFilterById === billToPartyFilterId ? BillToParty.indexOf(criterionMeta.value) : criterionArgumentValue;
  const criterionArgumentValueAsArrayIfNeeded =
    adjustedCriterionArgumentValue && matchedFilter?.expectsArgumentAsArray && !Array.isArray(adjustedCriterionArgumentValue)
      ? [adjustedCriterionArgumentValue]
      : adjustedCriterionArgumentValue;
  let adjustedOperatorValue = criterionOperatorValue;
  if (
    (criterionOperatorValue && type === OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER) ||
    (criterionArgumentValue && type === OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK)
  ) {
    adjustedOperatorValue = criterionOperatorValue === 'equals';
  }
  if (!criterionArgumentValue && type === OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK) {
    adjustedOperatorValue = criterionOperatorValue === 'empty';
  }
  return {
    id: adjustedFilterById,
    value: criterionArgumentValueAsArrayIfNeeded,
    operator: { value: adjustedOperatorValue },
  };
};
